import { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component - scrolls to top of page on route change
 * This fixes the issue where navigating between pages shows content from the bottom
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  // Disable browser's automatic scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  // Force scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  // Use useLayoutEffect for synchronous scroll before paint
  useLayoutEffect(() => {
    // Only scroll if pathname actually changed
    if (prevPathname.current !== pathname) {
      scrollToTop();
      prevPathname.current = pathname;
    }
  }, [pathname]);

  // Also use useEffect as a fallback after render with multiple attempts
  useEffect(() => {
    // Immediate scroll
    scrollToTop();
    
    // Scroll again after a short delay (for async content)
    const timer1 = setTimeout(scrollToTop, 50);
    const timer2 = setTimeout(scrollToTop, 100);
    const timer3 = setTimeout(scrollToTop, 200);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
